import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPageV4() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-1201">
      <HeroSection data-id="element-1202" />
      <PainSection data-id="element-1203" />
      <TruthSection data-id="element-1204" />
      <ProductPresentation data-id="element-1205" />
      <ContentBreakdown data-id="element-1206" />
      <BenefitsSection data-id="element-1207" />
      <TestimonialsSection data-id="element-1208" />
      <ForYouSection data-id="element-1209" />
      <GuaranteeSection data-id="element-1210" />
      <BonusSection data-id="element-1211" />
      <ValueStack basePrice={18.9} popupStrikethroughPrice="$30.88 USD" popupSpecialPrice="$27.29 USD" data-id="element-1212" />
      <FAQSection data-id="element-1213" />
      <ImpactPhrases data-id="element-1214" />
      <Footer data-id="element-1215" />
    </div>;
}